module.exports = __webpack_public_path__ + "img/adv-landing-car.317284de.png";